<template>
  <section class="section">
    <div class="container">
      <h1 class="title">{{ $translate('catalogs') | capitalize }}</h1>
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button
              v-if="permissions.canCreate"
              type="is-primary"
              icon-right="plus"
              @click="isModalActive = true"
            ></b-button>
          </div>
        </div>
        <div class="level-right"></div>
      </div>

      <b-table
        :data="filteredData"
        :paginated="tableOptions.isPaginated"
        :narrowed="true"
        :per-page="tableOptions.perPage"
        :current-page.sync="tableOptions.currentPage"
        :pagination-simple="tableOptions.isPaginationSimple"
        :sort-icon="tableOptions.sortIcon"
        :sort-icon-size="tableOptions.sortIconSize"
        :loading="tableOptions.loading"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        hoverable
      >
        <template slot-scope="props">
          <b-table-column field="name" :label="$translate('catalog_name') | capitalize" sortable>
            {{ props.row.name }}
          </b-table-column>
          <b-table-column field="type" :label="$translate('type') | capitalize" sortable>
            <b-tag class="module-tag" :type="$moduleConfiguration[props.row.type].tagColor">{{
              $translate(props.row.type)
            }}</b-tag>
          </b-table-column>

          <b-table-column :label="$translate('action') | capitalize">
            <a
              @click="
                $router.push({
                  name: 'editCatalog',
                  params: { id: props.row.id, module: props.row.type },
                })
              "
            >
              <b-icon icon="pencil-outline"></b-icon>
            </a>
            <a
              v-if="permissions.canCreate"
              @click="
                $router.push({
                  name: 'newCatalog',
                  params: { idtocopy: props.row.id, module: props.row.type },
                })
              "
            >
              <b-icon icon="content-copy"></b-icon>
            </a>
            <a v-if="permissions.canDelete" @click="deleteOccurence(props.row.id, props.row.type)">
              <b-icon icon="delete-outline"></b-icon>
            </a>
          </b-table-column>
        </template>
      </b-table>
    </div>

    <b-modal v-model="isModalActive" :active="isModalActive" :width="640" scroll="keep">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('select_catalog_type') | capitalize }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-field>
            <b-radio v-model="catalogType" native-value="tailored">
              {{ $translate('catalogTailored') }}
            </b-radio>
          </b-field>
          <b-field>
            <b-radio v-model="catalogType" native-value="fits">
              {{ $translate('catalogFits') }}
            </b-radio>
          </b-field>
          <b-field>
            <b-radio v-model="catalogType" native-value="modular">
              {{ $translate('catalogModular') }}
            </b-radio>
          </b-field>
          <b-field>
            <b-radio v-model="catalogType" native-value="insole">
              {{ $translate('catalogInsole') }}
            </b-radio>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button class="button is-primary" type="button" @click="navToModule(catalogType)">
            {{ $translate('Continue') | capitalize }}
          </b-button>
          <button class="button" type="button" @click="isModalActive = false">
            {{ $translate('close') | capitalize }}
          </button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
//import firebase from "firebase";
import mainMixin from '@/helpers/mixins/mainMixin'
import permissionMixin from '@/helpers/mixins/permissionMixin'
import firebase from 'firebase'

export default {
  name: 'Catalog',
  components: {},
  mixins: [mainMixin, permissionMixin],
  data() {
    return {
      loading: true,
      catalogType: 'tailored',
      isModalActive: false,
    }
  },
  mounted() {
    let permissionDenied = true
    switch (this.userInfo.type) {
      case 'A':
        permissionDenied = false
        this.permissions.canCreate = true
        this.permissions.canEdit = true
        this.permissions.canHide = true
        this.permissions.canDelete = true
        break
      case 'I':
        if (this.userInfo.level === 'S') {
          this.permissions.canCreate = true
          this.permissions.canEdit = true
          this.permissions.canDelete = true
        }
        permissionDenied = false
        break
    }
    if (permissionDenied) this.$router.push('/forbidden')
    this.loadData()
  },
  methods: {
    deleteOccurence(idtoerase, type) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('catalog_message_destroy'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('catalog_message_confirm'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          const batch = this.$db.batch()
          const catalogToRemove = this.$moduleConfiguration[type].catalogType
          this.$db
            .collection('companies')
            .where(catalogToRemove, '==', idtoerase)
            .get()
            .then(async companies => {
              companies.forEach(doc => {
                const updateData = { [catalogToRemove]: firebase.firestore.FieldValue.delete() }
                batch.update(this.$db.collection('companies').doc(doc.id), updateData)
              })
              await batch.commit()
            })
          this.$db
            .collection('catalogs')
            .doc(idtoerase)
            .delete()
            .then(async () => {
              this.loadData()
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_delete'),
              })
            })
        },
      })
    },
    loadData() {
      this.tableData = []
      this.$db
        .collection('catalogs')
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let newcat = doc.data()
            newcat.id = doc.id
            if (!newcat.type) {
              newcat.type = 'tailored'
            }
            this.tableData.push(newcat)
          })
          this.filteredData = this.tableData
          this.tableOptions.loading = false
        })
    },
    navToModule(module) {
      this.$router.push({
        name: 'newCatalog',
        params: {
          module,
        },
      })
    },
  },
}
</script>
